import { render, staticRenderFns } from "./PasswordForgotten.vue?vue&type=template&id=488cd0fe"
import script from "./PasswordForgotten.vue?vue&type=script&lang=js"
export * from "./PasswordForgotten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports